import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/zt_404.png'


const _hoisted_1 = {
  class: "my_debit",
  style: {"margin-top":"0.7rem"}
}
const _hoisted_2 = { class: "my_debit_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  class: "right",
  style: {"border-radius":"0.08rem"}
}
const _hoisted_5 = { class: "he" }
const _hoisted_6 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_7 = {
  key: 0,
  style: {"height":"550px"}
}
const _hoisted_8 = {
  key: 0,
  style: {"height":"550px"}
}
const _hoisted_9 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable, ElMessage } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRoute, useRouter } from "vue-router";
import Tooltip from "@/components/Tooltip/index.vue";

interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'my_debit',
  setup(__props) {

const router = useRouter();
const route = useRoute();
document.title = "标识山西-我的发票";
let pageDef = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const page = pageDef;
const atcIdex = ref(0);
const SetAtcIdex = (index: number) => {
  atcIdex.value = index;
  if (index == 0) {
    init();
  } else {
    init1();
  }
};
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      // TODO: improvement typing when refactor table
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const totalPay = ref(0.0);
const totalAmount = () => {
  let sum = 0;
  multipleSelection.value.forEach((item) => {
    sum += item.price;
  });

  totalPay.value = sum.toFixed(2);
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  totalAmount();
};

const tableData = ref([]);
const init = () => {
  Axios(
    "get",
    "/fodder/invoice/my-list",
    {
      pageIndex: page.value.pageNum,
      pageSize: page.value.pageSize,
    },
    false,
    function (res) {
      tableData.value = res.data.rows;
      page.value.total = res.data.total;
    }
  );
};
const init1 = () => {
  Axios(
    "post",
    "/material/material/invoice/my",
    {
      pageIndex: page.value.pageNum,
      pageSize: page.value.pageSize,
    },
    false,
    function (res: any) {
      tableData.value = res.data.data.records;
      page.value.total = res.data.data.total;
    }
  );
};

init();

//全选
const allCheckbox = ref(false);
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  if (allCheckbox.value) {
    tableData.value.forEach((item, index) => {
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
  } else {
    tableData.value.forEach((item, index) => {
      multipleTableRef.value!.toggleRowSelection(item, false);
    });
  }
};
//查看发票
const myDebitView = () => {
  if (
    multipleSelection.value.length > 1 ||
    multipleSelection.value.length == 0
  ) {
    ElMessage({
      message: "只能选择一条数据查看发票",
      type: "warning",
    });

    return;
  }
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: multipleSelection.value[0].id,
      type: "view",
    },
  });
};

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const openopen = (val: string) => {
  val = val.replace(/^http:\/\//i, "https://");
  window.open(val, "_bank");
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate, { left_tabShow: 'my_debit' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["div1", { selected: atcIdex.value == 0 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (SetAtcIdex(0)))
          }, " 素材发票 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["div1", { selected: atcIdex.value == 1 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (SetAtcIdex(1)))
          }, " 业务发票 ", 2)
        ]),
        _withDirectives(_createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: tableData.value,
          style: {"width":"100%"},
          height: "430"
        }, {
          empty: _withCtx(() => [
            (tableData.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[9] || (_cache[9] = [
                  _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                    _createElementVNode("img", {
                      style: {"width":"100%","margin":"0 auto"},
                      src: _imports_0
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "orderNo",
              width: "190",
              label: "订单号"
            }),
            _createVNode(_component_el_table_column, {
              property: "title",
              label: "商品名称"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(scope.row.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "price",
              label: "实付金额",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              property: "type",
              label: "付款方式",
              width: "100"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" 线上支付 ")
              ])),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "createTime",
              label: "下单时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              property: "status",
              label: "开票状态"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 0)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("未开票")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("已开票")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "invoiceCode",
              label: "发票号"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.invoiceCode ? scope.row.invoiceCode : "/"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: ($event: any) => (openopen(scope.row.pdf))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("查看")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (scope.row.status == 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "info",
                        link: "",
                        disabled: ""
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("查看")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]), [
          [_vShow, atcIdex.value == 0]
        ]),
        _withDirectives(_createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: tableData.value,
          style: {"width":"100%"},
          height: "430"
        }, {
          empty: _withCtx(() => [
            (tableData.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[15] || (_cache[15] = [
                  _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                    _createElementVNode("img", {
                      style: {"width":"100%","margin":"0 auto"},
                      src: _imports_0
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "needNo",
              width: "190",
              label: "订单号"
            }, {
              default: _withCtx((scope) => [
                _createVNode(Tooltip, {
                  text: scope.row.needNo ? scope.row.needNo : '暂无'
                }, null, 8, ["text"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "amount",
              label: "实付金额"
            }),
            _createVNode(_component_el_table_column, {
              property: "type",
              label: "付款方式"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" 线上支付 ")
              ])),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "payTime",
              label: "下单时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              property: "status",
              label: "开票状态"
            }, {
              default: _withCtx((scope) => [
                (!scope.row.pdf)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("未开票")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("已开票")
                      ])),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "num",
              label: "发票号"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.num ? scope.row.num : "/"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                (scope.row.pdf)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      onClick: ($event: any) => (openopen(scope.row.pdf))
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("查看")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "info",
                      link: "",
                      disabled: ""
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("查看")
                      ])),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]), [
          [_vShow, atcIdex.value == 1]
        ]),
        _createElementVNode("div", _hoisted_9, [
          (tableData.value.length != 0)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                "current-page": _unref(page).pageNum,
                "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).pageNum) = $event)),
                "page-size": _unref(page).pageSize,
                "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(page).pageSize) = $event)),
                onSizeChange: sizeChange,
                onCurrentChange: currentChange,
                style: {"margin":"0.4rem 0"},
                background: "",
                layout: "prev, pager, next",
                total: _unref(page).total
              }, null, 8, ["current-page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})